// extracted by mini-css-extract-plugin
export default {"wrap":"TenantAvatar_wrap__SXskC"};